var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 5.26a.9.9 0 011.28 0L12 10.73l5.46-5.47a.9.9 0 011.28 1.28L13.27 12l5.47 5.46a.9.9 0 11-1.28 1.28L12 13.27l-5.46 5.47a.9.9 0 11-1.28-1.28L10.73 12 5.26 6.54a.9.9 0 010-1.28z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTUuMjYgNS4yNmEuOS45IDAgMCAxIDEuMjggMEwxMiAxMC43M2w1LjQ2LTUuNDdhLjkuOSAwIDAgMSAxLjI4IDEuMjhMMTMuMjcgMTJsNS40NyA1LjQ2YS45LjkgMCAxIDEtMS4yOCAxLjI4TDEyIDEzLjI3bC01LjQ2IDUuNDdhLjkuOSAwIDEgMS0xLjI4LTEuMjhMMTAuNzMgMTIgNS4yNiA2LjU0YS45LjkgMCAwIDEgMC0xLjI4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgCancelOutline24 as ReactComponent };